import { features } from '!/flags'
import { model as router } from '!/router'
import { model as config, remote } from '@/config'
import { combine, createEvent, createStore, sample, type Store } from 'effector'
import { runtime } from '~/app'
import { type ViewError } from './index.h'

export const redirectToSignIn = createEvent<void>()

// debounced error, in order to prevent react to render component with old data
export const $viewError = createStore<ViewError>(null)

// indicates about enabled or disabled registration
export const $enabled: Store<boolean> = combine(
  features.get('registrationEnabled', false),
  config.get(remote.tria_isRegistrationEnabled),
  (registrationEnabled, fbRegistrationEnabled) => {
    // TODO: temporary fix for KaroStream. Should be removed after WBS 2.6 released for KaroStream.
    //  On the 20.03.2023 WBS version is 1.46.3
    if (runtime.app.name === 'karostream') return true

    return registrationEnabled && fbRegistrationEnabled
  }
) // `false` by default

// indicates about enabled or disabled registration by phone
export const $signUpWithPhoneEnabled: Store<boolean> = features.get(
  'signInWithPhoneEnabled',
  false
) // `false` by default

export const $link: Store<string> = // '' by default
  config.get(remote.tria_registrationExternalDomain)

sample({
  clock: redirectToSignIn,
  fn: () => '/sign-in',
  target: router.navigatePush,
})
